var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffercard2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 644,
    height: 440,
    viewBox: "0 0 644 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 644,
    height: 440,
    rx: 16,
    fill: "#E6F4FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 42.2351C30 35.6077 35.3726 30.2351 42 30.2351H168C174.627 30.2351 180 35.6077 180 42.2351V117.766C180 124.393 174.627 129.766 168 129.766H42C35.3726 129.766 30 124.393 30 117.766V42.2351Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 42C30 35.3726 35.3726 30 42 30H121.274V130H42C35.3726 130 30 124.627 30 118V42Z",
    fill: "white",
    fillOpacity: 0.64
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.273 73.6619H180V118C180 124.627 174.627 130 168 130H121.273V73.6619Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffercard2);
export default __webpack_public_path__ + "static/media/offercard2.0567ed87f43f4d5b6c24a0e5d4464130.svg";
export { ForwardRef as ReactComponent };